(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-launcher"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('contact-launcher')) {
    class ContactLauncher extends HTMLElement {
      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';

        this.panel = this.querySelector('.contact-launcher__panel');
        this.menu = this.querySelector('[data-menu]');
        this.toggleButton = this.querySelector('[data-menu-toggle]');
        this.whatsappButton = this.querySelector('[data-launcher="whatsapp"]');
        this.inboxButton = this.querySelector('[data-launcher="inbox"]');
        this.panelClose = this.querySelector('[data-launcher-close]');
        this.status = this.querySelector('[data-inbox-status]');
        this.inboxTries = 0;

        this.onDocumentClick = (event) => {
          if (this.contains(event.target)) return;
          this.closePanel(false);
          this.closeMenu(false);
        };

        this.onKeydown = (event) => {
          if (event.key !== 'Escape') return;
          if (this.isPanelOpen()) this.closePanel(true);
          else this.closeMenu(true);
        };

        if (this.toggleButton) {
          this.toggleButton.addEventListener('click', () => this.toggleMenu());
        }

        if (this.whatsappButton) {
          this.whatsappButton.addEventListener('click', () => this.openPanel());
        }

        if (this.panelClose) {
          this.panelClose.addEventListener('click', () => this.closePanel(true));
        }

        if (this.inboxButton) {
          this.inboxButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.closePanel(false);
            this.closeMenu(false);
            window.setTimeout(() => this.openInbox(), 0);
          });
        }

        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onKeydown);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onKeydown);
        window.clearInterval(this.inboxTimer);
        window.clearTimeout(this.menuTimer);
        window.clearTimeout(this.panelTimer);
      }

      motionDuration() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 460;
      }

      isPanelOpen() {
        return this.dataset.panelOpen === 'true';
      }

      isMenuOpen() {
        return this.dataset.menuOpen === 'true';
      }

      toggleMenu() {
        if (this.isMenuOpen()) this.closeMenu(true);
        else this.openMenu();
      }

      openMenu() {
        if (!this.menu || !this.toggleButton || this.isMenuOpen()) return;
        window.clearTimeout(this.menuTimer);
        this.menu.hidden = false;
        this.menu.getBoundingClientRect();
        this.dataset.menuOpen = 'true';
        this.toggleButton.setAttribute('aria-expanded', 'true');
        this.toggleButton.setAttribute('aria-label', this.toggleButton.dataset.labelOpen);
      }

      closeMenu(restoreFocus) {
        if (!this.isMenuOpen()) return;
        this.closePanel(false);
        this.dataset.menuOpen = 'false';
        if (this.toggleButton) {
          this.toggleButton.setAttribute('aria-expanded', 'false');
          this.toggleButton.setAttribute('aria-label', this.toggleButton.dataset.labelClosed);
          if (restoreFocus) this.toggleButton.focus({ preventScroll: true });
        }
        this.menuTimer = window.setTimeout(() => {
          if (this.dataset.menuOpen === 'true') return;
          this.menu.hidden = true;
        }, this.motionDuration());
      }

      openPanel() {
        if (!this.panel || this.isPanelOpen()) return;
        window.clearTimeout(this.panelTimer);
        this.panel.hidden = false;
        this.panel.getBoundingClientRect();
        this.dataset.panelOpen = 'true';
        if (this.whatsappButton) this.whatsappButton.setAttribute('aria-expanded', 'true');
        if (this.panelClose) this.panelClose.focus({ preventScroll: true });
      }

      closePanel(restoreFocus) {
        if (!this.isPanelOpen()) return;
        this.dataset.panelOpen = 'false';
        if (this.whatsappButton) this.whatsappButton.setAttribute('aria-expanded', 'false');
        if (restoreFocus && this.whatsappButton) this.whatsappButton.focus({ preventScroll: true });
        this.panelTimer = window.setTimeout(() => {
          if (this.dataset.panelOpen === 'true') return;
          this.panel.hidden = true;
        }, this.motionDuration());
      }

      openInbox() {
        window.clearInterval(this.inboxTimer);
        this.inboxTries = 0;
        if (this.activateInbox()) return;

        this.inboxTimer = window.setInterval(() => {
          this.inboxTries += 1;
          if (this.activateInbox() || this.inboxTries > 20) {
            window.clearInterval(this.inboxTimer);
            if (this.inboxTries > 20 && this.status) this.status.hidden = false;
          }
        }, 300);
      }

      isChatOpen(chat) {
        if (!chat) return false;
        if (chat.hasAttribute('open') || chat.open === true) return true;
        const runtime = chat.shadowRoot && chat.shadowRoot.querySelector('shopify-agent-runtime');
        return Boolean(runtime && (runtime.hasAttribute('open') || runtime.open === true));
      }

      activateInbox() {
        const chat = document.querySelector('shopify-chat');
        if (chat && customElements.get('shopify-chat') && typeof chat.show === 'function') {
          chat.show();
          if (this.status) this.status.hidden = true;
          return true;
        }

        if (this.isChatOpen(chat)) {
          if (this.status) this.status.hidden = true;
          return true;
        }

        const button = this.findActivator(document, 0);
        if (button) {
          button.click();
          if (this.status) this.status.hidden = true;
          return true;
        }

        if (chat) {
          if (typeof chat.open !== 'function') chat.open = true;
          chat.setAttribute('open', '');
          const runtime = chat.shadowRoot && chat.shadowRoot.querySelector('shopify-agent-runtime');
          if (runtime) {
            if (typeof runtime.open !== 'function') runtime.open = true;
            runtime.setAttribute('open', '');
          }
          if (this.status) this.status.hidden = true;
          return this.isChatOpen(chat);
        }

        return false;
      }

      findActivator(root, depth) {
        if (!root || depth > 8) return null;
        const button = root.querySelector('button.activator, button[part="activator"], button[aria-controls="chat-widget"], button[aria-label="Open chat"]');
        if (button) return button;

        const nodes = root.querySelectorAll('*');
        for (let index = 0; index < nodes.length; index += 1) {
          if (!nodes[index].shadowRoot) continue;
          const nested = this.findActivator(nodes[index].shadowRoot, depth + 1);
          if (nested) return nested;
        }

        return null;
      }
    }

    customElements.define('contact-launcher', ContactLauncher);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lighter-experience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lighter-experience')) {
    class LighterExperience extends HTMLElement {
      static resolved = new Map();
      static pending = new Map();
      static context = null;

      static audioContext() {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return null;
        if (!LighterExperience.context) LighterExperience.context = new Ctx();
        if (LighterExperience.context.state === 'suspended') {
          LighterExperience.context.resume().catch(() => {});
        }
        return LighterExperience.context;
      }

      static load(url) {
        if (!url) return Promise.reject(new Error('missing audio'));
        if (LighterExperience.resolved.has(url)) return Promise.resolve(LighterExperience.resolved.get(url));
        if (LighterExperience.pending.has(url)) return LighterExperience.pending.get(url);
        const job = fetch(url)
          .then((response) => response.arrayBuffer())
          .then((data) => {
            const context = LighterExperience.audioContext();
            if (!context) throw new Error('audio');
            return context.decodeAudioData(data.slice(0));
          })
          .then((buffer) => {
            LighterExperience.resolved.set(url, buffer);
            LighterExperience.pending.delete(url);
            return buffer;
          })
          .catch((error) => {
            LighterExperience.pending.delete(url);
            throw error;
          });
        LighterExperience.pending.set(url, job);
        return job;
      }

      connectedCallback() {
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';
        this.mount();
      }

      disconnectedCallback() {
        this.destroy();
        delete this.dataset.bound;
      }

      mount() {
        this.alive = true;
        this.opened = false;
        this.flameMode = 'off';
        this.muted = false;
        this.hasIgnited = false;
        this.onScreen = true;
        this.gust = 0;
        this.targetGust = 0;
        this.lastGust = 0;
        this.jetSource = null;
        this.jetGain = null;
        this.oneShots = [];
        this.flameLoop = false;
        this.waveLoop = false;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.urls = {
          open: this.dataset.audioOpen,
          close: this.dataset.audioClose,
          lever: this.dataset.audioLever,
          jet: this.dataset.audioJet
        };
        this.device = this.querySelector('[data-device]');
        this.lid = this.querySelector('[data-lid]');
        this.lever = this.querySelector('[data-lever]');
        this.wheel = this.querySelector('[data-wheel]');
        this.guide = this.querySelector('[data-guide]');
        this.guideText = this.querySelector('[data-guide-text]');
        this.closeGuide = this.querySelector('[data-close]');
        this.live = this.querySelector('[data-live]');
        this.soundButton = this.querySelector('.lighter-sound');
        this.canvas = this.querySelector('.lighter-flame');
        this.ctx = this.canvas.getContext('2d', { alpha: true });
        this.wave = this.querySelector('.lighter-wave canvas');
        this.waveCtx = this.wave ? this.wave.getContext('2d') : null;
        this.dualTex = new Image();
        this.jetTex = new Image();
        this.flameScaleX = 0;
        this.onResize = () => {
          this.flameScaleX = 0;
          if (this.flameLoop) this.fitFlameCanvas();
        };
        window.addEventListener('resize', this.onResize);
        this.prepareFlames();
        this.sounds = {};
        Object.keys(this.urls).forEach((name) => {
          if (!this.urls[name]) return;
          const audio = new Audio(this.urls[name]);
          audio.preload = 'auto';
          if (name === 'jet') audio.loop = true;
          this.sounds[name] = audio;
        });
        this.visualCue = null;
        this.spectrum = new Uint8Array(256);
        this.timeData = new Uint8Array(512);
        this.barCount = 47;
        this.barSmoothed = new Float32Array(this.barCount);
        this.onPointerDown = () => this.prepareAudio();
        this.addEventListener('pointerdown', this.onPointerDown, { passive: true });
        this.lid.addEventListener('click', () => this.toggleLid());
        this.lever.addEventListener('click', () => this.strike());
        this.wheel.addEventListener('click', () => this.strike());
        this.guide.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!this.opened) this.toggleLid();
          else this.strike();
        });
        this.closeGuide.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.closeLid();
        });
        if (this.soundButton) {
          this.soundButton.addEventListener('click', () => this.toggleSound());
        }
        this.observer = new IntersectionObserver((entries) => {
          this.setScreen(entries[0].isIntersecting);
        }, { threshold: 0.12 });
        this.observer.observe(this);
        this.updateGuide();
        if (this.waveCtx) this.startWave();
      }

      destroy() {
        this.alive = false;
        this.stopJet();
        this.haltFlame();
        this.waveLoop = false;
        if (this.waveFrame) cancelAnimationFrame(this.waveFrame);
        this.oneShots.forEach((source) => {
          try { source.stop(); } catch (error) {}
        });
        this.oneShots = [];
        if (this.pressTimer) clearTimeout(this.pressTimer);
        if (this.warmTimer) clearTimeout(this.warmTimer);
        if (this.warmIdle && window.cancelIdleCallback) window.cancelIdleCallback(this.warmIdle);
        if (this.observer) this.observer.disconnect();
        window.removeEventListener('resize', this.onResize);
        this.removeEventListener('pointerdown', this.onPointerDown);
        if (this.gain) this.gain.disconnect();
        if (this.analyser) this.analyser.disconnect();
        Object.keys(this.sounds || {}).forEach((name) => {
          this.sounds[name].pause();
        });
      }

      prepareAudio() {
        this.ensureGraph();
        Object.keys(this.urls).forEach((name) => {
          if (!this.urls[name]) return;
          LighterExperience.load(this.urls[name]).then(() => {
            if (!this.alive || name !== 'jet') return;
            if (this.opened && this.flameMode === 'jet' && !this.muted && this.onScreen && this.sounds.jet) {
              this.sounds.jet.pause();
              this.scheduleJet();
            }
          }).catch(() => {});
        });
      }

      ensureGraph() {
        const context = LighterExperience.audioContext();
        if (!context || this.gain) return context;
        this.gain = context.createGain();
        this.analyser = context.createAnalyser();
        this.analyser.fftSize = 512;
        this.analyser.smoothingTimeConstant = 0.72;
        this.gain.connect(this.analyser);
        this.analyser.connect(context.destination);
        return context;
      }

      cueWave(kind, delay) {
        this.visualCue = { kind: kind, start: performance.now() + delay };
      }

      playNamed(name, delaySeconds) {
        if (!this.urls[name]) return;
        const buffer = LighterExperience.resolved.get(this.urls[name]);
        const context = this.ensureGraph();
        if (name !== 'jet') this.cueWave(name, this.muted ? 0 : delaySeconds * 1000);
        if (this.muted) return;
        if (buffer && context) {
          const source = context.createBufferSource();
          source.buffer = buffer;
          source.connect(this.gain);
          source.start(context.currentTime + delaySeconds);
          this.oneShots.push(source);
          source.onended = () => {
            this.oneShots = this.oneShots.filter((item) => item !== source);
            try { source.disconnect(); } catch (error) {}
          };
          return;
        }
        this.playElement(name);
      }

      playElement(name) {
        if (this.muted) return;
        const audio = this.sounds[name];
        if (!audio) return;
        try {
          audio.pause();
          audio.currentTime = 0;
          const pending = audio.play();
          if (pending && pending.catch) pending.catch(() => {});
        } catch (error) {}
      }

      stopJet() {
        if (this.jetSource) {
          try { this.jetSource.stop(); } catch (error) {}
          try { this.jetSource.disconnect(); } catch (error) {}
          this.jetSource = null;
        }
        if (this.jetGain) {
          try { this.jetGain.disconnect(); } catch (error) {}
          this.jetGain = null;
        }
        if (this.sounds && this.sounds.jet) {
          this.sounds.jet.pause();
          try { this.sounds.jet.currentTime = 0; } catch (error) {}
        }
      }

      scheduleJet() {
        if (this.muted || !this.opened || this.flameMode !== 'jet' || !this.onScreen || !this.sounds.jet) return;
        const buffer = LighterExperience.resolved.get(this.urls.jet);
        const context = this.ensureGraph();
        if (buffer && context) {
          if (this.jetSource) return;
          this.sounds.jet.pause();
          try {
            const source = context.createBufferSource();
            source.buffer = buffer;
            source.loop = true;
            const channel = buffer.getChannelData(0);
            const rate = buffer.sampleRate;
            let lo = 0;
            let hi = buffer.length - 1;
            const threshold = 0.0015;
            while (lo < hi && Math.abs(channel[lo]) < threshold) lo += 1;
            while (hi > lo && Math.abs(channel[hi]) < threshold) hi -= 1;
            source.loopStart = Math.max(0, (lo - 128) / rate);
            source.loopEnd = Math.min(buffer.duration, (hi + 128) / rate);
            const volume = context.createGain();
            volume.gain.value = 0.3;
            source.connect(volume);
            volume.connect(this.gain);
            source.start();
            this.jetSource = source;
            this.jetGain = volume;
            return;
          } catch (error) {}
        }
        try {
          this.sounds.jet.volume = 0.3;
          const pending = this.sounds.jet.play();
          if (pending && pending.catch) pending.catch(() => {});
        } catch (error) {}
      }

      pulse(kind) {
        if (typeof navigator.vibrate !== 'function') return;
        const patterns = { open: [18, 35, 28], close: [28], ignite: [16, 38, 16], switch: [18] };
        try { navigator.vibrate(patterns[kind] || 16); } catch (error) {}
      }

      toggleLid() {
        if (this.opened) this.closeLid();
        else this.openLid();
      }

      openLid() {
        if (this.opened) return;
        this.pulse('open');
        this.prepareAudio();
        this.opened = true;
        this.flameMode = 'off';
        this.hasIgnited = false;
        this.stopJet();
        const ready = LighterExperience.resolved.has(this.urls.open);
        this.playNamed('open', ready ? 0.31 : 0);
        this.refresh();
      }

      closeLid() {
        if (!this.opened) return;
        this.pulse('close');
        this.opened = false;
        this.flameMode = 'off';
        this.hasIgnited = false;
        this.stopJet();
        this.playNamed('close', 0);
        this.refresh();
      }

      strike() {
        if (!this.opened) return;
        this.pulse(this.flameMode === 'off' ? 'ignite' : 'switch');
        this.prepareAudio();
        this.device.classList.remove('lever-pressed');
        void this.device.offsetWidth;
        this.device.classList.add('lever-pressed');
        clearTimeout(this.pressTimer);
        this.pressTimer = setTimeout(() => this.device.classList.remove('lever-pressed'), 155);
        if (this.flameMode === 'off') {
          if (!this.hasIgnited) {
            this.playNamed('lever', 0);
            this.hasIgnited = true;
          }
          this.flameMode = 'dual';
          this.stopJet();
        } else if (this.flameMode === 'dual') {
          this.flameMode = 'jet';
          this.stopJet();
          this.scheduleJet();
        } else {
          this.flameMode = 'dual';
          this.stopJet();
        }
        this.refresh();
      }

      toggleSound() {
        this.muted = !this.muted;
        if (!this.soundButton) return;
        this.soundButton.classList.toggle('is-muted', this.muted);
        this.soundButton.textContent = this.muted ? this.dataset.soundOff : this.dataset.soundOn;
        this.soundButton.setAttribute('aria-pressed', this.muted ? 'false' : 'true');
        if (this.muted) this.stopJet();
        else if (this.opened && this.flameMode === 'jet') this.scheduleJet();
      }

      updateGuide() {
        let step = 'step-open';
        let text = this.dataset.labelOpen;
        if (this.opened && this.flameMode === 'off') {
          step = 'step-dual';
          text = this.dataset.labelIgnite;
        } else if (this.opened && this.flameMode === 'dual') {
          step = 'step-jet';
          text = this.dataset.labelJet;
        } else if (this.opened && this.flameMode === 'jet') {
          step = 'step-jet';
          text = this.dataset.labelSoft;
        }
        this.guide.className = 'lighter-guide is-on ' + step;
        this.guideText.textContent = text;
        this.guide.setAttribute('aria-label', text);
        this.closeGuide.hidden = !this.opened;
        this.closeGuide.classList.toggle('is-on', this.opened);
        this.lid.setAttribute('aria-label', this.opened ? this.dataset.labelClose : this.dataset.labelOpen);
        const wheelLabel = this.flameMode === 'off' ? this.dataset.labelIgnite : (this.flameMode === 'dual' ? this.dataset.labelJet : this.dataset.labelSoft);
        this.wheel.setAttribute('aria-label', this.opened ? wheelLabel : this.dataset.labelIgnite);
        this.lever.setAttribute('aria-label', this.opened ? wheelLabel : this.dataset.labelIgnite);
        if (this.live) this.live.textContent = text;
      }

      refresh() {
        this.device.classList.toggle('is-open', this.opened);
        if (this.opened && this.flameMode !== 'off' && this.onScreen) this.startFlame();
        else this.clearFlame();
        this.device.classList.toggle('is-burning', this.opened && this.flameMode !== 'off');
        this.updateGuide();
      }

      setScreen(visible) {
        this.onScreen = visible;
        if (!visible) {
          this.stopJet();
          this.haltFlame();
          return;
        }
        if (this.opened && this.flameMode !== 'off') this.startFlame();
        if (this.opened && this.flameMode === 'jet' && !this.muted) this.scheduleJet();
      }

      prepareFlames() {
        const ready = Promise.all([
          this.bindTexture(this.querySelector('[data-flame-kind="dual"]') || this.dataset.flameDual, (image) => { this.dualTex = image; }),
          this.bindTexture(this.querySelector('[data-flame-kind="jet"]') || this.dataset.flameJet, (image) => { this.jetTex = image; })
        ]);
        ready.then(() => {
          if (!this.alive) return;
          const warm = () => {
            if (!this.alive) return;
            this.warmFlame();
            if (this.opened && this.flameMode !== 'off' && this.onScreen) this.startFlame();
          };
          if (window.requestIdleCallback) this.warmIdle = window.requestIdleCallback(warm, { timeout: 400 });
          else this.warmTimer = window.setTimeout(warm, 50);
        });
      }

      bindTexture(source, assign) {
        if (!source) return Promise.resolve();
        const image = typeof source === 'string' ? new Image() : source;
        if (typeof source === 'string') image.decoding = 'async';
        let settled = false;
        return new Promise((resolve) => {
          const finish = () => {
            if (settled) return;
            if (!image.naturalWidth) {
              if (image.complete) {
                settled = true;
                resolve();
              }
              return;
            }
            settled = true;
            const decoded = image.decode ? image.decode() : Promise.resolve();
            decoded.then(() => {
              assign(image);
              resolve();
            }).catch(() => {
              assign(image);
              resolve();
            });
          };
          image.addEventListener('load', finish);
          image.addEventListener('error', () => {
            if (settled) return;
            settled = true;
            resolve();
          });
          if (typeof source === 'string') image.src = source;
          if (image.complete) finish();
        });
      }

      fitFlameCanvas() {
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const rect = this.canvas.getBoundingClientRect();
        let cssW = rect.width;
        let cssH = rect.height;
        if (cssW < 8 || cssH < 8) {
          const scale = parseFloat(getComputedStyle(this.device).getPropertyValue('--s')) || 0.36;
          cssW = 600 * scale;
          cssH = 800 * scale;
        }
        let w = Math.max(2, Math.round(cssW * dpr));
        let h = Math.max(2, Math.round(cssH * dpr));
        const edge = Math.max(w, h);
        if (edge > 960) {
          const fit = 960 / edge;
          w = Math.max(2, Math.round(w * fit));
          h = Math.max(2, Math.round(h * fit));
        }
        if (this.canvas.width !== w || this.canvas.height !== h) {
          this.canvas.width = w;
          this.canvas.height = h;
        }
        this.flameScaleX = w / 600;
        this.flameScaleY = h / 800;
      }

      warmFlame() {
        if (this.flameWarmed || this.flameLoop || !this.ctx) return;
        const tex = (this.dualTex && this.dualTex.naturalWidth) ? this.dualTex : this.jetTex;
        if (!tex || !tex.naturalWidth) return;
        this.flameWarmed = true;
        this.fitFlameCanvas();
        const ctx = this.ctx;
        ctx.setTransform(this.flameScaleX, 0, 0, this.flameScaleY, 0, 0);
        ctx.save();
        ctx.globalAlpha = 0.01;
        ctx.filter = 'blur(17px)';
        ctx.drawImage(tex, 180, 200, 80, 220);
        ctx.filter = 'blur(24px)';
        ctx.drawImage(tex, 220, 180, 70, 240);
        ctx.restore();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      }

      startFlame() {
        this.renderFlame(performance.now());
        if (this.flameLoop) return;
        this.flameLoop = true;
        const step = (now) => {
          if (!this.flameLoop || !this.alive) return;
          this.renderFlame(now);
          this.flameFrame = requestAnimationFrame(step);
        };
        this.flameFrame = requestAnimationFrame(step);
      }

      haltFlame() {
        this.flameLoop = false;
        if (this.flameFrame) cancelAnimationFrame(this.flameFrame);
        this.flameFrame = 0;
      }

      clearFlame() {
        this.haltFlame();
        if (!this.ctx) return;
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
      }

      drawWarped(ctx, image, sx, sw, baseX, baseY, dw, dh, now, seed) {
        const srcH = image.naturalHeight || image.height || 0;
        if (!srcH || !(image.naturalWidth || image.width)) return;
        const slice = Math.max(4, Math.ceil(srcH / 70));
        const bob = 0.965 + 0.045 * Math.sin(now * (4.6 + seed * 0.31) + seed * 1.6) + 0.022 * Math.sin(now * (12.1 + seed * 0.23) + seed);
        const height = dh * bob;
        const offsetY = baseY - height;
        for (let y = 0; y < srcH; y += slice) {
          const h = Math.min(slice, srcH - y);
          const along = 1 - (y + h * 0.5) / srcH;
          const power = Math.pow(along, 1.3);
          const swirl = (Math.sin(now * (4.9 + seed * 0.12) + y * 0.041 + seed) * 7 + Math.sin(now * 9.8 - y * 0.058 + seed * 2) * 3 + this.gust * (seed === 2.3 ? 4 : 10)) * power;
          const widthWarp = 1 + (0.034 * Math.sin(now * 8.7 + y * 0.083 + seed) + 0.018 * Math.sin(now * 17.2 + y * 0.12 + seed)) * power;
          const yy = offsetY + (y / srcH) * height;
          ctx.drawImage(image, sx, y, sw, h, baseX - (dw * widthWarp) / 2 + swirl, yy, dw * widthWarp, (h / srcH) * height + 1.2);
        }
      }

      dualParts() {
        const width = this.dualTex.naturalWidth || this.dualTex.width;
        if (this.dataset.flameDualLayout === 'sprite') return [[0, 85], [82, 82]];
        const half = Math.max(1, Math.round(width / 2));
        return [[0, half], [Math.max(0, width - half), half]];
      }

      renderFlame(nowMs) {
        if (!this.ctx) return;
        const time = this.reduced ? 0 : nowMs * 0.001;
        if (!this.flameScaleX) this.fitFlameCanvas();
        const ctx = this.ctx;
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        if (!this.opened || this.flameMode === 'off') return;
        const ready = this.flameMode === 'dual'
          ? this.dualTex.naturalWidth
          : this.jetTex.naturalWidth;
        if (!ready) return;
        if (nowMs - this.lastGust > 130) {
          this.targetGust = (Math.random() - 0.5) * 1.45;
          this.lastGust = nowMs;
        }
        this.gust += (this.targetGust - this.gust) * 0.065;
        if (this.reduced) this.gust = 0;
        ctx.setTransform(this.flameScaleX, 0, 0, this.flameScaleY, 0, 0);
        const rootX = 288;
        const rootY = 712;
        if (this.flameMode === 'dual') {
          const parts = this.dualParts();
          ctx.save();
          ctx.globalAlpha = 0.3;
          ctx.filter = 'blur(17px)';
          this.drawWarped(ctx, this.dualTex, parts[0][0], parts[0][1], rootX - 105, rootY, 250, 610, time, 1.2);
          this.drawWarped(ctx, this.dualTex, parts[1][0], parts[1][1], rootX + 102, rootY, 250, 586, time, 3.7);
          ctx.restore();
          ctx.save();
          ctx.globalAlpha = 0.88 + 0.08 * Math.sin(time * 18.1);
          this.drawWarped(ctx, this.dualTex, parts[0][0], parts[0][1], rootX - 105, rootY, 238, 598, time, 1.2);
          ctx.globalAlpha = 0.91 + 0.06 * Math.sin(time * 17.4 + 1.5);
          this.drawWarped(ctx, this.dualTex, parts[1][0], parts[1][1], rootX + 102, rootY, 238, 582, time, 3.7);
          ctx.restore();
        } else {
          ctx.save();
          ctx.globalAlpha = 0.4;
          ctx.filter = 'blur(24px)';
          this.drawWarped(ctx, this.jetTex, 0, this.jetTex.naturalWidth, rootX, rootY, 196, 736, time, 2.3);
          ctx.restore();
          ctx.save();
          ctx.globalAlpha = 0.9 + 0.07 * Math.sin(time * 18.4);
          this.drawWarped(ctx, this.jetTex, 0, this.jetTex.naturalWidth, rootX, rootY, 188, 720, time, 2.3);
          ctx.restore();
        }
      }

      startWave() {
        if (this.waveLoop || !this.waveCtx) return;
        this.waveLoop = true;
        const draw = () => {
          if (!this.waveLoop || !this.alive) return;
          this.drawWave();
          this.waveFrame = requestAnimationFrame(draw);
        };
        this.waveFrame = requestAnimationFrame(draw);
      }

      visualSignal(now) {
        if (this.flameMode === 'jet' && this.opened) {
          const phase = now * 0.001;
          return { level: 0.24 + 0.1 * Math.sin(phase * 12) ** 2 + 0.07 * Math.sin(phase * 19) ** 2, kind: 'jet' };
        }
        if (!this.visualCue) return { level: 0, kind: 'idle' };
        const elapsed = (now - this.visualCue.start) / 1000;
        if (elapsed < 0) return { level: 0, kind: this.visualCue.kind };
        const duration = this.visualCue.kind === 'open' ? 1.35 : this.visualCue.kind === 'close' ? 0.36 : 0.42;
        if (elapsed >= duration) return { level: 0, kind: 'idle' };
        const envelope = Math.exp(-elapsed * (this.visualCue.kind === 'open' ? 2.7 : 6.2));
        return { level: Math.max(0, 0.14 + 0.48 * envelope) * Math.sin(Math.min(1, elapsed / 0.035) * Math.PI / 2), kind: this.visualCue.kind };
      }

      drawWave() {
        const canvas = this.wave;
        const ctx = this.waveCtx;
        const w = canvas.width;
        const h = canvas.height;
        ctx.clearRect(0, 0, w, h);
        let rms = 0;
        if (this.analyser && !this.muted) {
          this.analyser.getByteTimeDomainData(this.timeData);
          this.analyser.getByteFrequencyData(this.spectrum);
          for (let i = 0; i < this.timeData.length; i += 1) {
            const sample = (this.timeData[i] - 128) / 128;
            rms += sample * sample;
          }
          rms = Math.sqrt(rms / this.timeData.length);
        }
        const simulated = this.visualSignal(performance.now());
        const visualLevel = Math.max(rms, simulated.level);
        const active = visualLevel > 0.0065;
        const gap = 2.5;
        const barW = 2.75;
        const fullWidth = (this.barCount - 1) * (barW + gap) + barW;
        const left = (w - fullWidth) / 2;
        const grad = ctx.createLinearGradient(0, 0, 0, h);
        grad.addColorStop(0, 'rgba(203,212,226,.35)');
        grad.addColorStop(0.5, 'rgba(255,255,255,.98)');
        grad.addColorStop(1, 'rgba(203,212,226,.35)');
        ctx.fillStyle = grad;
        ctx.shadowBlur = 4;
        ctx.shadowColor = 'rgba(230,236,248,.22)';
        for (let i = 0; i < this.barCount; i += 1) {
          const center = Math.pow(Math.sin((Math.PI * (i + 0.5)) / this.barCount), 1.45);
          const bin = 3 + Math.floor(Math.pow(i / (this.barCount - 1), 1.5) * 75);
          const sensed = this.analyser && !this.muted ? this.spectrum[Math.min(bin, 255)] / 255 : 0;
          const rhythmic = 0.33 + 0.67 * Math.abs(Math.sin(performance.now() * 0.012 + i * 0.29) * Math.cos(performance.now() * 0.004 + i * 0.13));
          const normalized = active ? Math.max(sensed, simulated.level * rhythmic * 1.38) : 0;
          const idleBase = 1.4 + center * 3.8;
          const reactive = active ? center * (normalized * 66 + Math.min(visualLevel * 90, 30)) : 0;
          const target = Math.min(h - 8, active ? 2.5 + reactive : idleBase);
          this.barSmoothed[i] += (target - this.barSmoothed[i]) * (active ? 0.32 : 0.18);
          const height = Math.max(1.6, this.barSmoothed[i]);
          const x = left + i * (barW + gap);
          ctx.beginPath();
          ctx.roundRect(x, (h - height) / 2, barW, height, barW / 2);
          ctx.fill();
        }
        ctx.shadowBlur = 0;
      }
    }

    customElements.define('lighter-experience', LighterExperience);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
